// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_fh-0";
export var headerCellHover = "_fh-1";
export var readCellContainer = "_fh-2";
export var unreadIndicator = "_fh-3";